import React, { FunctionComponent } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { CustomInput } from "../../../CustomInput";
import { ISectionProps } from "../ISectionProps";
import { Ii360State } from "../../IState";
import { Button } from "../../../Button";
import { NewInputDialog } from "../NewInputDialog";
import { useNewInput } from "../../new-input.hook";

export const I360Section: FunctionComponent<ISectionProps<Ii360State>> = (props) => {
    const {
        data,
        onChange
    } = props;

    const {
        isNewInputDialogOpen,
        toggleNewInputDialog
    } = useNewInput();

    return (
        <Box ml={2} mt={1} >
            <Typography sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18, mb: 1 }} >
                i360
            </Typography>
            <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
                <CustomInput
                    name="webhookAddress"
                    width={220}
                    height={35}
                    value={data.webhookAddress}
                    onChange={onChange}
                    label={{ text: "Webhook Address", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="webhook address"
                />
                <CustomInput
                    name="defaultSource"
                    width={220}
                    height={35}
                    value={data.defaultSource}
                    onChange={onChange}
                    label={{ text: "Default Source", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="default source"
                />
                <CustomInput
                    name="defaultSourceType"
                    width={220}
                    height={35}
                    value={data.defaultSourceType}
                    onChange={onChange}
                    label={{ text: "Default Source Type", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="default source type"
                />
                <CustomInput
                    name="defaultInterest"
                    width={220}
                    height={35}
                    value={data.defaultInterest}
                    onChange={onChange}
                    label={{ text: "Default Interest", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="default interest"
                />
                {
                    props.fields.map((field, index) => {
                        const objName = Object.keys(field)[0] as keyof typeof field;

                        return (
                            <CustomInput
                                width={220}
                                height={35}
                                label={{ text: objName.toString() }}
                                name={objName.toString()}
                                value={field[objName]}
                                onChange={(event) => props.onChangeField(event as React.ChangeEvent<HTMLInputElement>, index)}
                            />
                        )
                    })
                }
            </Box>
            <Box mt={2} >
                <Button label="Add new field" width={120} height={35} onClick={toggleNewInputDialog} />
            </Box>
            <NewInputDialog
                open={isNewInputDialogOpen}
                onClose={toggleNewInputDialog}
                onClick={(name, value) => {
                    props.onAdd(name, value);
                    toggleNewInputDialog();
                }}
            />
        </Box>
    )
}